/**
 * Data Structure for creating request and response "interceptor" (or event) pipeline.
 */
export class InterceptorList {
  constructor () {
    this.request = new Interceptor();
    this.response = new Interceptor();
  }
}

/**
 * A tool for managing and iterating items in a pipeline.
 */
class Interceptor {
  constructor () {
    this._handlers = [];
  }

  /**
   * Install success and failure handlers into the pipe
   * @param onSuccess
   * @param onError
   * @returns {number} - the ID of the interceptor. Use to eject it from the pipeline.
   */
  use (onSuccess, onError) {
    this._handlers.push({ onSuccess, onError });
    return this._handlers.length - 1;
  }

  /**
   * Removes an interceptor from the pipe.
   * @param id
   */
  eject (id) {
    if (this._handlers[id]) {
      this._handlers[id] = null;
    }
  }

  /**
   * Walk the list of registered handlers.
   * @param fn - callback that receives each item in the list.
   */
  forEach (fn) {
    this._handlers.filter((h) => !!h).forEach((h) => fn(h));
  }
}
